// extracted by mini-css-extract-plugin
export default {"container":"amount_container__E4LW8","copyBtn":"amount_copyBtn__ROqVh","copyBtnIcon":"amount_copyBtnIcon__f+rwp","amount":"amount_amount__ikhfA"};